(function () {
    const body = document.body;

    body.addEventListener('submit', function (e) {
        const form = e.target.closest('[name="ajax-form"]');
        if (!form || !body.contains(form)) return;

        e.preventDefault();

        const submitBtn = form.querySelector('[type="submit"]');
        let d = {};

        if (window.location.search.substring(1) !== "") {
            d = Object.assign({}, parse_query_string(window.location.search.substring(1)));
        }

        d.action = 'covebo_ajax';
        d.subaction = form.dataset.subaction;

        // fill post data
        form.querySelectorAll('input.form-control').forEach(function (elem) {
            d[elem.getAttribute('name')] = elem.value;
        });

        submitBtn.classList.add('btn--loading');

        setTimeout(function () {
            fetch(window.ajaxurl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: new URLSearchParams(d).toString()
            })
                .then(function (response) {
                    if (!response.ok) throw new Error('Request failed');
                    return response.json();
                })
                .then(function (data) {
                    submitBtn.classList.remove('btn--loading');
                    submitBtn.classList.add(data.success ? 'btn--succes' : 'btn--alert');
                    new Modal(data.msg.title, data.msg.text, data.success);

                    if (data.success) {
                        form.querySelectorAll('input').forEach(function (el) {
                            if (el.type === 'checkbox') {
                                el.checked = false;
                            } else {
                                const isHidden = el.offsetParent === null;
                                if (!isHidden) {
                                    el.value = "";
                                }
                            }
                        });

                        handleDataLayer(d);
                    }
                })
                .catch(function () {
                    submitBtn.classList.remove('btn--loading');
                    submitBtn.classList.add('btn--alert');
                })
                .finally(function () {
                    setTimeout(function () {
                        submitBtn.classList.remove('btn--loading');
                        submitBtn.classList.remove('btn--success');
                        submitBtn.classList.remove('btn--alert');
                    }, 3000);
                });
        }, 2000);
    });

    function handleDataLayer(data) {
        const { action, subaction, email } = data;
        const dataLayer = window.dataLayer || [];
        if (!Cookies.get('covebo_email') && email) {
            Cookies.set('covebo_email', md5(email));
        }

        const user_id = Cookies.get('covebo_email') || 'undefined';

        switch (subaction) {
            case 'call-me-back':
                dataLayer.push({
                    event: 'recruiter_call_me_submit',
                    user: { user_id }
                });
                break;
            case 'favorites':
                dataLayer.push({
                    event: 'wishlist_submit',
                    user: { user_id }
                });
                break;
            case 'jobalert':
                dataLayer.push({
                    event: 'job_alert_submit',
                    user: { user_id }
                });
                break;
            default:
                break;
        }
    }

    function parse_query_string(query) {
        const vars = query.split("&");
        const query_string = {};
        for (let i = 0; i < vars.length; i++) {
            const pair = vars[i].split("=");
            const key = decodeURIComponent(pair[0]);
            const value = decodeURIComponent(pair[1]);
            if (typeof query_string[key] === "undefined") {
                query_string[key] = decodeURIComponent(value);
            } else if (typeof query_string[key] === "string") {
                const arr = [query_string[key], decodeURIComponent(value)];
                query_string[key] = arr;
            } else {
                query_string[key].push(decodeURIComponent(value));
            }
        }
        return query_string;
    }

})();